import axios from 'axios'
import Account from './account'
import store from '../store'


const cleanAndRedirect = () => {
  store.dispatch('cleanStorage')

  setTimeout(() => {
    window.location.href = `${window.location.protocol}//${window.location.host}/login/entrar`
  })
}

export const refreshToken = (originalRequest) => {
  if (Object.prototype.hasOwnProperty.call(originalRequest.headers, 'x-access-token')) {
    return Account.renewToken(originalRequest.headers)
  }

  return Promise.reject(new Error('OriginalRequest doesn`t have Access-Token Header'))
}

export const custAxios = (headers) => {
  const storage = window.localStorage

  let customHeaders = {
    ...headers
  }

  if (storage.getItem('access_token')) {
    customHeaders = {
      ...customHeaders,
      'x-access-token': storage.getItem('access_token')
    }
  }

  const instance = axios.create({ headers: customHeaders })

  instance.interceptors.response.use(async (config) => config, async (error) => {
    try {
      if (error.response && error.response.data && error.response.data.code) {
        if (error.response.status === 401) {
          if (error.response.data.code === 'invalid_token') {
            const originalRequest = error.config

            const resToken = await refreshToken(originalRequest)

            if (resToken.status === 200 && (resToken.data.access_token || resToken.data.includes('access_token'))) {
              storage.setItem('access_token', resToken.data.access_token)
              storage.setItem('refresh_token', resToken.data.refresh_token)

              originalRequest.headers['x-access-token'] = resToken.data.access_token

              return axios(originalRequest)
            }

            return resToken
          }

          if (error.response.data.code === 'invalid_refresh_token') {
            cleanAndRedirect()
          }
        }

        if (error.response.status === 400 && error.response.data.code === 'header_required_not_informed' && error.response.data.message.includes('X-Access-Token or X-Api-Key')) {
          cleanAndRedirect()
        }
      }

      return Promise.reject(error.response)
    } catch (err) {
      return Promise.reject(err)
    }
  })

  return instance
}
